import DriverForm from "../lp/DriverForm";
import { usePageSetup } from "./usePageSetup";

/** /drivers — ABテストのB（こだわり条件の設問あり） */
export default function DriverB() {
  usePageSetup("B");
  return <DriverForm variant="B" />;
}
